<template>
  <div>
    <ASNavbar />
    <router-view />
    <ASFooter />
  </div>
</template>

<script>
import ASNavbar from '../components/ASNavbar.vue';
import ASFooter from '../components/ASFooter.vue';

export default {
  name: 'StandardLayout',
  components: {
    ASNavbar,
    ASFooter,
  },
};
</script>
